// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"az_VHb","modalTooltip":"az_WHb"};